export function useEventBus(selector, classToCall) {
    document.addEventListener('hdEventBusInit', () => {
        const components = {};
        (<any>window).hdEventBus.on(selector, (id = null) => {
            const selectorId = `${selector}${id ? id : ''}`;
            if (components[selectorId]) {
                components[selectorId].onDestroy();
                delete components[selectorId];
            }
            const querySelector = `.${selector}${id ? '[data-hd-component-id='+ id +']' : ''}`;
            const el = <HTMLElement>document.querySelector(querySelector);
            if (el) {
                components[selectorId] = new classToCall(el);
                setTimeout(() => {
                    components[selectorId].onInit();
                }, 0);
            }
        });
    });
}